import { getNumbersFromStr } from '@alfa-bank/site-form-helpers/text/get-numbers-from-str';

export const trimValue = (value: string | number) => value.toString().trim();

/* Функция используется для проверки наличия пробела в инпуте, где значение поделено на разряды */
export const hasSpaceCheck = (value: string) => /\s/.test(value);

// TODO поисследовать, можем ли обойтись без getNumbersFromStr (ALFABANKRU-38816)
/* Функция используется для приведения строки к числовому типу.
 * Если число целое или в строке есть пробелы, то сначала вытащить из строки все цифры (getNumbersFromStr)
 * Если нецелое, то возвращаем его, т.к getNumbersFromStr удаляет всё кроме цифр (важно для шага 0.5 в slider-field)
 *  */
export const modifyToValidValue = (value: string | number) => {
    const trimmedValue = trimValue(value);
    const hasSpace = hasSpaceCheck(trimmedValue);

    return Number.isInteger(Number(trimmedValue)) || hasSpace
        ? Number(getNumbersFromStr(trimmedValue))
        : Number(trimmedValue);
};
